import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=6faf39f0&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"
import style0 from "./Screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports